import { z } from 'zod';
import { DOCUMENT_ID_LENGTH } from '../constants';
import { requiredApplicationIdString } from '../helper';
import { IncomeDocumentType, SUPPORTED_INCOME_DOCUMENT_TYPES } from '../types';

export const verifyIncomeDocumentUploadSchema = z.object({
  applicationId: requiredApplicationIdString(),
  documentIds: z
    .array(z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`))
    .min(1, 'At least one document ID is required'),
  documentType: z
    .nativeEnum(IncomeDocumentType)
    .refine(documentType => (SUPPORTED_INCOME_DOCUMENT_TYPES as readonly IncomeDocumentType[]).includes(documentType), {
      message: 'Unsupported income document type',
    })
    .optional(),
});

export const incomeDocumentVerificationSchema = verifyIncomeDocumentUploadSchema.pick({
  applicationId: true,
  documentIds: true,
});
